import ReactMarkdown from "react-markdown";
import { ProductDetail } from "../../../../../../graphql/operations";
import ChapterMedia from "../ChapterMedia";
import styles from "./Chapter.module.css";

interface Props {
  detail: ProductDetail;
}

export default function Chapter({ detail }: Props) {
  return (
    <div className={styles.DetailPartsChapter}>
      <h2>{detail.translation.name}</h2>
      <ReactMarkdown>{detail.translation.story}</ReactMarkdown>
      <div className={styles.DetailPartsChapterMedia}>
        <ChapterMedia media={detail.media} />
      </div>
    </div>
  );
}
